export class SoYearWiseShippedDetails {
    finYear: string;
    finMonth: string;
    plantCode: string;
    dispatchCount: string;
}